import { GrowthHighlight } from '@/components/dashboard/GrowthHighlight'
import { StreakWidget } from '@/components/dashboard/StreakWidget'
import { VocabStatsWidget } from '@/components/dashboard/VocabStatsWidget'
import { Card } from '@/components/ui/Card'
import { copy } from '@/lib/copy'
import type { GrowthData, Streak, VocabSummary } from '@/api/dashboard'

interface DashboardStatsPanelProps {
  growth: GrowthData
  streak: Streak
  vocabularyStats: VocabSummary
  isNewUser: boolean
}

export function DashboardStatsPanel({
  growth,
  streak,
  vocabularyStats,
  isNewUser,
}: DashboardStatsPanelProps) {
  return (
    <Card className="overflow-hidden">
      {!isNewUser ? (
        <div className="border-b border-border/60 px-5 py-4">
          <GrowthHighlight growth={growth} />
        </div>
      ) : (
        <div className="border-b border-border/60 px-5 py-4">
          <p className="text-sm text-muted-foreground">{copy.onboarding.dashboardHint}</p>
        </div>
      )}

      <div className="grid md:grid-cols-2 md:divide-x md:divide-border/60">
        <div className="border-b border-border/60 p-5 md:border-b-0">
          <StreakWidget streak={streak} embedded />
        </div>
        <div className="p-5">
          <VocabStatsWidget stats={vocabularyStats} isNewUser={isNewUser} embedded />
        </div>
      </div>
    </Card>
  )
}
